module.exports = __webpack_public_path__ + "static/media/image_1.5f7ccd9b.jpg";